import { useMemo } from 'react';
import {
  CHAT_INCIDENT_ID,
  DRAWER_TYPE,
  INCIDENT_ID,
  INCIDENT_OVERVIEW_TAB,
} from '@elementary/common-ui/constants/urlParams';
import useSearchParams from '@elementary/common-ui/hooks/useSearchParams';

const useIncidentOverviewSidePanel = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const openIncidentOverview = (incidentId: string) => {
    setSearchParams((prev) => {
      prev.set(INCIDENT_ID, incidentId);
      return prev;
    });
  };

  const closeIncidentOverview = () => {
    setSearchParams((prev) => {
      prev.delete(INCIDENT_ID);
      prev.delete(INCIDENT_OVERVIEW_TAB);
      return prev;
    });
  };

  const hasIncidentId = !!searchParams.get(INCIDENT_ID);
  const hasDrawerType = !!searchParams.get(DRAWER_TYPE);
  const hasChatIncidentId = !!searchParams.get(CHAT_INCIDENT_ID);

  // Hide incident panel when test/asset panel or AI chat is open to avoid double drawers
  const isOpen = useMemo(
    () => hasIncidentId && !hasDrawerType && !hasChatIncidentId,
    [hasIncidentId, hasDrawerType, hasChatIncidentId],
  );

  return {
    isOpen,
    onOpen: openIncidentOverview,
    onClose: closeIncidentOverview,
    selectedIncidentId: searchParams.get(INCIDENT_ID) || undefined,
  };
};

export default useIncidentOverviewSidePanel;
